export const build = {"tag":"v1.0.5","hash":"b6a8f512","time":"261013.1005"}